import React from 'react'
import '../../components/AppButtonSelect/ButtonSelect.scss'
import { format } from 'date-fns'
import { cs } from 'date-fns/locale'
import { useQuery } from 'react-query'
import { RouteComponentProps, useParams } from 'react-router-dom'
import BackButton from '../../components/AppBackButton/BackButton'
import LabelValue from '../../components/AppLabelValue/LabelValue'
import TableContainer from '../../components/AppTableContainer/TableContainer'
import MainLayout from '../../components/TheMainLayout/MainLayout'
import Video from '../../components/AppVideo/Video'
import { getPersonalTest } from '../../moduls/personal-tests'
import { PersonalTestTerm } from '../../services/types'
import { testDateTermDescription } from '../../services/utils'
import Loader from '../../components/AppLoader/Loader'

const PersonalTestDetail: React.FC<RouteComponentProps> = (props) => {
  const { id } = useParams<{ id: string }>()
  const { data: course, isFetched } = useQuery<{ name: string; term: PersonalTestTerm }>(
    ['personal-course', { id: +id }],
    getPersonalTest
  )

  if (!isFetched || !course?.term) return <Loader />
  if (!course) return null

  const term = course.term

  return (
    <>
      <MainLayout>
        <div className="h-text-center">
          <h1>{course.name}</h1>
          {/*
                    <p className="h-mb-2">Níže naleznete podklady z poslední konané lekce</p>
                    */}
        </div>
        <label>Pokyny pro účastníky</label>
        <TableContainer className="h-mb-2">
          <div className="container-row">
            <div className="col-sm-12">
              <ul>
                <li>
                  Dostavte se <strong>nejpozději 20 minut před začátkem akce</strong> na uvedenou
                  adresu konání přijímacích zkoušek nanečisto.
                </li>
                <li>
                  Vezměte si s sebou <strong>psací a rýsovací potřeby</strong>
                </li>
                <li>
                  Doporučujeme <strong>pití a drobnou svačinu</strong>
                </li>
              </ul>
            </div>
          </div>
        </TableContainer>
        <label>Info k termínu</label>
        <TableContainer className="h-mb-2">
          <div className="container-row">
            <div className="col-sm-6">
              <LabelValue
                className="h-mb-15"
                label="Adresa"
                value={`${term.location.city.name} · ${term.location.street_name} ${term.location.street_number}`}
              />
            </div>
            <div className="col-sm-6">
              <LabelValue
                className="h-mb-15"
                label="Datum konání"
                value={testDateTermDescription({ dateFrom: term.date_from })}
              />
            </div>
            <div className="col-sm-6">
              <LabelValue
                className="h-mb-15"
                label="Termín konání"
                value={
                  term.date_from
                    ? `${format(new Date(term.date_from), 'EEEE', { locale: cs })}${
                        term.time_from
                          ? ` · ${format(new Date(`1970-01-01T${term.time_from}`), 'p', {
                              locale: cs
                            })}`
                          : ''
                      }`
                    : ''
                }
              />
            </div>
            {/*
                        <div className="col-sm-6">
                            <LabelValue className="h-mb-15" label="Lektor" value={`${term.lector?.name ?? ''}`} />
                        </div>
                        */}
          </div>
        </TableContainer>

        <label>Předměty</label>
        {term.subjects &&
          term.subjects.map((s) => (
            <TableContainer className="h-mb-2">
              <div className="container-row">
                <div className="col-sm-12 pb-3" key={s.id}>
                  <h3 className="h-mb-1">{s.name}</h3>
                  <p className="mb-0">
                    Maximální počet bodů: <strong>{s.max_points}</strong>
                    {s.user_points !== null && (
                      <>
                        <br />
                        Vaše výsledky: <strong>{s.user_points} bodů</strong>
                      </>
                    )}
                  </p>

                  {!!s.video?.length && (
                    <div className="h-mt-2">
                      <hr />
                      <p className="h-mb-1">Videa:</p>
                      {s.video
                        .filter((v) => v) // odfiltruje null
                        .map((videoUrl, i) => (
                          <Video key={i} url={videoUrl} className="h-mb-2" />
                        ))}
                    </div>
                  )}

                  {!!s.materials?.length && (
                    <div className="h-mt-2">
                      <hr />
                      <p className="h-mb-1">Studijní materiály:</p>
                      <ul className="h-ml-2">
                        {s.materials.map((material, i) => (
                          <li key={i}>
                            <a href={material.url ?? '#'} target="_blank" rel="noopener noreferrer">
                              {material.name}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </TableContainer>
          ))}

        {term.result_file && (
          <div className="h-mt-4 text-center">
            <p>
              <a
                href={term.result_file}
                target="_blank"
                rel="noopener noreferrer"
                className="button is-primary"
              >
                Stáhnout můj test
              </a>
            </p>
          </div>
        )}
      </MainLayout>
      <BackButton />
    </>
  )
}

export default PersonalTestDetail
